import {
  applogo,
  fifthscreen,
  firstscreen,
  forthscreen,
  logo,
  secondscreen,
  sixthscreen,
  thirdscreen,
} from "./assets";

export const appData = {
  name: "Status Saver",
  tagline: "Save WhatsApp Statuses Easily",
  description:
    "Keep your favorite WhatsApp photos and videos forever. Save image and video statuses before they disappear in 24 hours.",

  features: [
    {
      id: 1,
      icon: "Download",
      title: "Save Statuses Instantly",
      description:
        "Save WhatsApp image & video statuses with just one tap before they vanish",
    },
    {
      id: 2,
      icon: "FolderOpen",
      title: "Built-in Gallery",
      description: "Manage all your saved statuses in one organized gallery",
    },
    {
      id: 3,
      icon: "Share2",
      title: "Repost & Share",
      description:
        "Easily repost or share saved statuses directly from the app",
    },
    {
      id: 4,
      icon: "Zap",
      title: "Fast & Lightweight",
      description: "Quick, efficient design that works smoothly on any device",
    },
    {
      id: 5,
      icon: "Lock",
      title: "No Login Required",
      description: "Open and start saving immediately - no registration needed",
    },
    {
      id: 6,
      icon: "Shield",
      title: "Simple & Secure",
      description: "Easy-to-use interface with your privacy in mind",
    },
  ],

  howItWorks: [
    {
      step: 1,
      title: "View Status",
      description: "Open WhatsApp and view the status you want to keep",
    },
    {
      step: 2,
      title: "Open Status Saver",
      description: "Launch the Status Saver app on your device",
    },
    {
      step: 3,
      title: "Save & Enjoy",
      description: "Tap save and the status will be stored in your gallery",
    },
  ],

  screenshots: [
    {
      id: 1,
      url: firstscreen,
      alt: "Save WhatsApp Status",
    },
    {
      id: 2,
      url: secondscreen,
      alt: "Images & Videos Downloader",
    },
    {
      id: 3,
      url: thirdscreen,
      alt: "Instant Status Download",
    },
    {
      id: 4,
      url: forthscreen,
      alt: "Simple & Secure",
    },
    {
      id: 5,
      url: fifthscreen,
      alt: "No Contact Save Required",
    },
    {
      id: 6,
      url: sixthscreen,
      alt: "Simple & Secure",
    },
  ],

  logoUrl: applogo,

  links: {
    playStore:
      "https://play.google.com/store/apps/details?id=com.appsease.status.saver",
    github: "https://github.com/publicappsrepo/status-saver",
    privacyPolicy: "https://privacy-policy-status-saver.vercel.app/",
  },
};
